import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub';
import TagManagerService from 'services/TagManager';
import {actionsType} from 'config/constants';
import Stars from '../Stars';
import { useLogged } from 'hooks';
import RatingsStore from 'stores/new/Ratings';
import ReviewsActions from 'actions/Ratings';
import LoginService from 'services/Login';
import { useHistory } from "react-router-dom";
import { features } from 'config';
import Tooltip from 'components/Tooltip';
import style from './style.scss';

let actions = [];

const Average = ({single = false, sectionReview = false, productId, store, disableComments = false , itemId}) => {

    if(!productId || !features.productReviews) return '';

    const [reviewData, setReviewData] = useState(null);
    const [totalComments, setTotalComments] = useState();
    const isLogged = useLogged(false);
    const history = useHistory();
    
    useEffect(() => {
        if(store && store.ratings && productId){
            let current = store.ratings.get(productId);
            setReviewData(current ? current : null);
            PubSub.dispatch('reviews_average_data', {data: current ? current : null})
        }
    },[store, productId])


    useEffect(() => {
        _getRating(productId);
        const openDrawer = window?.location?.hash === '#reviews';
        if(openDrawer && productId && !sectionReview && !single){
            setTimeout(() => writeComment(), 500);
            history.replace(window?.location?.pathname);
        }
    }, [productId])

    useEffect(() => {
        actions.push(PubSub.register('reviews_total_comments', _totalComment));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[])
    
    const _getRating = (productId) => {
        ReviewsActions.getRatings(productId);
        
    }

    const writeComment = (isDownside = false) => {
        if(LoginService.isLogged()) {
            PubSub.dispatch(actionsType.DRAWER.WRITER_REVIEWS_OPEN, {productId, itemId });
        } else {
            PubSub.dispatch('login_open', {
                successCallback: () => {
                    setTimeout(() => {
                        PubSub.dispatch(actionsType.DRAWER.WRITER_REVIEWS_OPEN, {productId, itemId});
                    }, 1);
                }
            });
        }
        if(isDownside){
            TagManagerService.interaction('Escribir comentario (click módulo reviews)', itemId,  'PDP -Reviews');
        } else{
            TagManagerService.interaction('Escribir comentario (click)', itemId,  'PDP -Reviews');
        }

    }

    const _totalComment = (payload) => {
        const total = payload && payload.value ? payload.value.total : null;

        setTimeout(() => {
            setTotalComments(total)
        }, 1000)
        
    }

    const average = reviewData && reviewData.average;
    const rating = average;
    const totalCount = reviewData?.totalCount;
    const writeCommentButton = <button className={"new-link new-link-small average-comments " + (totalCount >= 1 ? ' comments ' : ' not-comments ')} onClick={ (() => writeComment(false)) }>Calificar producto</button>

    return (
        <>
            {!!((totalCount || disableComments) && (average > 0)) &&
                <div className="average">
                    <div className="average-stars-wrap">
                        {!sectionReview && <Stars rating={rating} single={single}/>}
                        {!!average && <span className="average-quantity">{average?.toFixed(1)}</span>}

                        <div className="average-section-review">
                            {sectionReview && totalCount >= 1 && <Stars rating={rating} single={single}/>}
                        </div>
                    </div>

                    {sectionReview && isLogged && <div className="average-section-review-write-comment">
                        <button className="primary-btn" onClick={ (() => writeComment(true)) }>Calificar producto</button>
                    </div>}

                    {!sectionReview && !single && totalCount && <div className="average-comments-wrap">
                        {!!totalComments && <a href="#reviews-ratings" className="average-comments-number">({totalCount})</a>}
                        {writeCommentButton}
                    </div>}
                </div>
            }

            {!sectionReview && !totalCount && !single && <Tooltip message='Ahora puedes calificar y reseñar un producto para compartir tu experiencia.' typeButton ='button' button='Entendido' timer={5000} once={true} type='tooltip_reviews'>{writeCommentButton}</Tooltip>}
        </>
    )
}

Average.propTypes = {
    productId: PropTypes.string,
    comment: PropTypes.bool,
    single: PropTypes.bool,
    sectionReview: PropTypes.bool,
    store: PropTypes.object,
    disableComments: PropTypes.bool,
    itemId : PropTypes.string
};

export default RatingsStore.wrapConsumer(Average);